import { render, staticRenderFns } from "./DomainSummaryTop5Table.vue?vue&type=template&id=dcf78db4&scoped=true"
import script from "./DomainSummaryTop5Table.vue?vue&type=script&lang=js"
export * from "./DomainSummaryTop5Table.vue?vue&type=script&lang=js"
import style0 from "./DomainSummaryTop5Table.vue?vue&type=style&index=0&id=dcf78db4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf78db4",
  null
  
)

export default component.exports